import { InjectionToken } from '@angular/core';
import { IAgentBuilderService } from './agent-builder.interface';

/**
 * DI seam for swapping the Mock service for the Real one in Phase C.
 * Components inject this token, never the concrete class.
 *
 * Bound in `app.config.ts` via `environment.useMockData` flag.
 */
export const AGENT_BUILDER_SERVICE = new InjectionToken<IAgentBuilderService>(
  'AGENT_BUILDER_SERVICE',
);
